import { Component } from '@angular/core';


@Component({
	selector: 'devo-commitments-tab-2-part',
	standalone: true,
	templateUrl: './devo-commitments-tab-2.part.html',
	styleUrls: [`./devo-commitments-tab-2.part.scss`],
})
export class DevoCommitmentsTab2Part {
}
